"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactBootstrap = require("react-bootstrap");
var _utils = require("../../utils");
var _richTextField = require("../../lib/richTextField");
var _lodash = require("lodash");
var _titleHeadTag = require("../../lib/titleHeadTag");
var _BlogCard = _interopRequireDefault(require("../../components/Blog/BlogCard"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 *  A react component to create a Blog Pin Post
 *
 * @param {object} props The properties passed into the object
 * @param {object} props.rendering Fields to render
 * @param {object} props.rendering.fields Fields
 *
 * @returns {React.ReactElement} A Blog Pin Post
 */
function BlogPinPost(props) {
  var _props$rendering;
  if (!((_props$rendering = props.rendering) !== null && _props$rendering !== void 0 && _props$rendering.fields)) return null;
  var BlogList = props.rendering.fields.BlogList;
  var extractedFields = (0, _utils.extractFieldsFn)(props);
  var hasHeaderOrDescription = !(0, _lodash.isEmpty)(extractedFields.Header.value) || !(0, _lodash.isEmpty)(extractedFields.Description.value);
  return /*#__PURE__*/_react.default.createElement("div", {
    id: (0, _utils.getComponentContentId)(props.rendering.dataSource),
    className: "container mm-spacing bloglist"
  }, hasHeaderOrDescription && /*#__PURE__*/_react.default.createElement("div", {
    className: 'blog-pinned-header'
  }, !(0, _lodash.isEmpty)(extractedFields.Header.value) && (0, _titleHeadTag.headTagTitle)(extractedFields.Header, "mm-text-center mm-spacing--minor blog-pinned-title", extractedFields.HeaderSize.value), !(0, _lodash.isEmpty)(extractedFields.Description.value) && /*#__PURE__*/_react.default.createElement("div", {
    className: "mm-text-center mm-spacing--minor blog-pinned-description"
  }, (0, _richTextField.parseHTML)(extractedFields.Description))), !(0, _lodash.isEmpty)(extractedFields.BlogList) && /*#__PURE__*/_react.default.createElement("div", {
    className: "container mm-spacing bloglist"
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Row, {
    className: "mm-spacing"
  }, (0, _lodash.map)(BlogList, (blog, key) => {
    // Need to restructure data from sitecore in the same fashion that the API returns data
    // as BlogCard expects the API response structure
    var structuredData = {
      authors: [],
      postDate: blog.fields.Date.value,
      url: blog.url,
      headline: blog.fields.Headline.value,
      blogThumbnail: blog.fields.Thumbnail.value.src,
      blogThumbnailAlt: blog.fields.Thumbnail.value.alt,
      overview: blog.fields.Overview.value
    };
    blog.fields.Author.forEach(author => {
      structuredData.authors.push({
        url: author.url,
        name: author.name
      });
    });
    return /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, {
      className: "align-self-stretch",
      lg: 4,
      sm: 12,
      key: key
    }, /*#__PURE__*/_react.default.createElement(_BlogCard.default, {
      item: structuredData,
      id: key,
      hideDate: true
    }));
  }))));
}
var _default = exports.default = BlogPinPost;